/* eslint-disable prettier/prettier */
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Replace these placeholder values with YOUR actual Firebase keys
const firebaseConfig = {
  apiKey: "AIzaSyDU8avNm6TnieB6k233vGuWAwPkef5MNks",
  authDomain: "mr-wafay-store.firebaseapp.com",
  projectId: "mr-wafay-store",
  storageBucket: "mr-wafay-store.firebasestorage.app",
  messagingSenderId: "58843474253",
  appId: "1:58843474253:web:8d0985175694e8448cef04",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Auth, Database, and Storage so we can use them in your dashboard screens
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

